import React, { Component } from 'react'
import "./index.less";

export default class Loading extends Component {
  render() {
    return (
      <div className="loading">
        <div>
          <canvas id="canvas1"></canvas>
          <canvas id="canvas2"></canvas>
          <canvas id="canvas3"></canvas>
        </div>
        {/* <span>Carregando...</span> */}
      </div>
    )
  }
}